const common = {
  'common.copy': 'Copier',
  'common.or': 'ou',
  'common.mandatory': 'Obligatoire',
  'common.not.mandatory': 'Optionnel',
  'common.details': 'Détails',
  'common.close': 'Fermer',
  'common.more': 'Plus',
  'common.retry': 'Réessayer',
  'common.causes': 'Causes possibles',
  'common.copied_to_clipboard': 'Copié dans le presse-papiers !',
  'common.copy_failed': 'Copie impossible',
  'common.yes': 'Oui',
  'common.no': 'Non',
};

const action = {
  'action.cancel': 'Annuler',
  'action.back': 'Retour',
  'action.come_back_later': 'Revenir plus tard',
  'action.filter': 'Filtrer',
  'action.send': 'Envoyer',
  'action.delete': 'Supprimer',
  'action.confirm': 'Confirmer',
};

const api = {
  'api.error': "Une erreur s'est produite, veuillez réessayer plus tard.",
};

const homepage = {
  'homepage.welcome': 'Bienvenue sur Vera',
  'homepage.subtitle': 'Plateforme de Gestion',
  'homepage.description':
    "Vera est votre outil centralisé pour gérer les paramètres de dématérialisation et les contrats de vos clients par Plateforme / Tenant. Conçue pour les équipes opérationnelles qui ont besoin d'efficacité, de traçabilité et de simplicité.",
  'homepage.modern_interface': 'Interface Intuitive',
  'homepage.modern_interface_description':
    'Navigation simple et actions rapides pour votre productivité',
  'homepage.feature.title': 'Fonctionnalités Clés',
  'homepage.feature.description':
    'Lister efficacement vos paramètres de dématérialisation et vos contrats par tenant et plateforme',
  'homepage.feature.pixid_config': 'Configuration',
  'homepage.feature.contracts_management': 'Gestion des Contrats',
  'homepage.feature.multi_platform': 'Multi-Plateforme',
  'homepage.feature.favorites': 'Recherches Favorites',
  'homepage.feature.pixid_config_description':
    'Configurez et consultez les paramètres de dématérialisation de vos clients par tenant et plateforme.',
  'homepage.feature.contracts_management_description':
    'Accédez et gérez la liste complète des contrats avec filtres avancés par statut, référence et agence.',
  'homepage.feature.orders_management': 'Gestion des Commandes',
  'homepage.feature.orders_management_description':
    "Consultez et filtrez l'ensemble des commandes avec des options de recherche avancées par numéro, agence et dates.",
  'homepage.feature.multi_platform_description':
    'Travaillez sur plusieurs plateformes et tenants en basculant facilement entre les environnements.',
  'homepage.feature.favorites_description':
    'Enregistrez vos recherches fréquentes pour un accès rapide aux configurations clients les plus consultées.',
  'homepage.platforms': 'Plateformes',
  'homepage.tenants': 'Tenants',
  'homepage.support': 'Support',
  'homepage.greeting': 'Bonjour {{name}}',
  'homepage.shortcuts.title': 'Accès rapide',
  'homepage.shortcut.pixid-contracts':
    'Consultez les contrats par plateforme, tenant, statut et référence.',
  'homepage.shortcut.pixid-orders':
    'Recherchez les commandes par numéro, agence et dates.',
  'homepage.shortcut.pixid-resources':
    'Retrouvez les intérimaires et leurs contrats par plateforme.',
  'homepage.shortcut.pixid-param-demat':
    'Paramètres de dématérialisation des clients par tenant et agence.',
  'homepage.shortcut.rubriques-clients':
    'Correspondances des rubriques clients avec les valeurs Anael.',
  'homepage.shortcut.document-mapping':
    'Mapping des documents entre plateformes.',
  'homepage.shortcut.client-vms-config':
    'Configuration VMS des clients par agence.',
  'homepage.clients': 'Clients',
};

const headerMenu = {
  'header.menu.home': 'Accueil',
  'header.menu.config': 'Configuration',
  'header.menu.config.heading_clients': 'Rubriques clients',
  'header.menu.config.document_mapping': 'Mapping des documents',
  'header.menu.dashboard': 'Tableau de Bord',
  'header.menu.pixid': 'Plateforme Pixid',
  'header.menu.pixid_dashboard': 'Paramètres Démat',
  'header.menu.pixid_contracts_dashboard': 'Contrats',
  'header.menu.pixid_orders_dashboard': 'Commandes',
  'header.menu.pixid_resources_dashboard': 'Intérimaires',
  'header.menu.config.client_vms_config': 'Configuration Client VMS',
};

const footer = {
  'footer.company.legal_notice':
    'Informations confidentielles à vocation interne uniquement.',
  'footer.development': 'Développé avec ❤️ par la Digital Factory.',
  'footer.last_update': 'Dernière mise à jour : {{- date }}',
};

const footerMenu = {
  'footer.menu.resources.title': 'Ressources',
  'footer.menu.support.title': 'Support',
  'footer.menu.company.title': 'Entreprise',
  'footer.menu.resources.documentation': 'Documentation',
  'footer.menu.resources.api': 'Api Référence',
  'footer.menu.resources.guide': 'Guide de démarrage',
  'footer.menu.support.help_center': "Centre d'Aide",
  'footer.menu.support.contact_team': "Contacter l'équipe",
  'footer.menu.support.bug': 'Signaler un Bug',
  'footer.menu.company.about': 'À Propos',
  'footer.menu.company.digital': 'Digital Factory',
  'footer.menu.company.confidentiality': 'Confidentialité',
};

const notifications = {
  'notifications.login.success': 'Connexion réussie ! Bienvenue {{- name }}',
  'notifications.logout.success':
    'Déconnexion réussie. À bientôt {{- name }} !',
  'notifications.error': "Une erreur s'est produite",
};

const userMenu = {
  'user.menu.login': 'Se connecter',
  'user.menu.logining': 'Connexion...',
  'user.menu.logout': 'Déconnexion',
  'user.menu.language': 'Langue',
  'user.menu.language_en': 'English',
  'user.menu.language_fr': 'Français',
  'user.menu.account': 'Mon compte',
};

const layout = {
  'layout.sidebar.collapse': 'Réduire le menu',
  'layout.sidebar.expand': 'Déplier le menu',
  'layout.sidebar.toggle': 'Afficher ou masquer le menu',
  'layout.sidebar.title': 'Menu principal',
  'layout.sidebar.description': "Navigation entre les pages de l'application.",
};

const authError = {
  'auth.error.401': 'Authentification Requise',
  'auth.error.403': 'Accès Refusé',
  'auth.error.404': "Service d'Authentification Introuvable",
  'auth.error.500': 'Erreur Serveur',
  'auth.error.default': "Échec de l'Authentification",
  'auth.error.scud.token': 'Votre token SCUD a expiré',
  'auth.error.scud.permission':
    "Vous n'avez pas l'autorisation d'accéder à cette application",
  'auth.error.scud.unavailable': "L'API SCUD est temporairement indisponible",
  'auth.error.reason.network': 'Problèmes de connectivité réseau',
  'auth.error.unauthorized':
    "Votre compte n'est peut-être pas autorisé pour ce service",
  'auth.error.scud.permission_changed':
    'Vos rôles/permissions ont peut-être changé',
  'auth.error.scud.api': "L'API SCUD rencontre des difficultés techniques",
  'auth.error.mainetanance': 'Une maintenance serveur peut être en cours',
  'auth.error.interuption': 'Interruption temporaire du service',
  'auth.error.try_again': 'Réessayer',
  'auth.error.development_mode':
    "💡 Conseil : Ajoutez {{ code }} à votre fichier .env pour contourner l'authentification en développement",
  'auth.error.id_request': 'ID de requête',
  'auth.error.too_many_attempts': 'Trop de tentatives d’authentification',
  'auth.error.too_many_attempts_description':
    "Nous avons tenté de vous authentifier {{- attempts }} fois sans succès. Pour éviter une boucle infinie, nous avons arrêté d'essayer.",
  'auth.error.too_many_attempts_suggestion': 'Étapes recommandées',
  'auth.error.reset_retry': 'Réinitialiser et Réessayer',
  'auth.error.ignore_auth': "Ignorer l'Auth (Dev)",
  'auth.error.clear_data':
    'Vider Toutes les Données du Navigateur et Réessayer',
  'auth.error.contact_admin':
    'Si ce problème persiste, veuillez contacter votre administrateur système',
  'auth.error.attempts.scud': 'Vérifiez votre accès SCUD',
  'auth.error.attempts.scud_description':
    "Assurez-vous d'avoir des identifiants valides et les permissions pour l'authentification SCUD",
  'auth.error.attempts.browser': 'Videz les données du navigateur',
  'auth.error.attempts.browser_description':
    'Effacez les cookies et le stockage local pour ce site si le problème persiste',
  'auth.error.attempts.contact': 'Contactez le support',
  'auth.error.attempts.contact_description':
    'Si le problème persiste, contactez votre administrateur informatique',
  'auth.error.attempts.loop': "Boucle d'authentification détectée",
  'auth.error.attempts.text': 'tentatives',
};

const dashboard = {
  'dashboard.title': 'Liste des Agences / Tenants',
  'dashboard.filters.title': 'Filtres',
  'dashboard.filters.reset': 'Réinitialiser les filtres',
};

const pixidDashboard = {
  'dashboard.pixid.title': 'Paramètres Démat',
  'dashboard.pixid.select_tenant': 'Sélectionner un Tenant',
  'dashboard.pixid.select_agency': 'Sélectionner une Agence',
  'dashboard.pixid.select_client': 'Sélectionner un Client',
  'dashboard.pixid.selection.title': 'Agence et client',
  'dashboard.pixid.search_agency_hint':
    'Tapez au moins 2 caractères pour rechercher un code agence',
  'dashboard.pixid.search_client_hint':
    'Tapez au moins 2 caractères pour rechercher un client',
  'dashboard.pixid.validate': 'Valider',
  'dashboard.pixid.loading': 'Chargement des données',
  'dashboard.pixid.client.legal_id': 'SIREN',
  'dashboard.pixid.client.address': 'Adresse',
  'dashboard.pixid.favorites.title': 'Mes Recherches',
  'dashboard.pixid.favorites.description':
    'Vous avez {{count}} recherche(s) favorite(s)',
  'dashboard.pixid.favorites.add': 'Ajouter aux favoris',
  'dashboard.pixid.favorites.remove': 'Retirer des favoris',
  'dashboard.pixid.favorites.platform': 'Plateforme',
  'dashboard.pixid.favorites.tenant': 'Tenant',
  'dashboard.pixid.favorites.section_clients': 'RECHERCHE PARAMÈTRES DEMAT',
  'dashboard.pixid.favorites.section_contracts': 'RECHERCHES CONTRATS',
  'dashboard.pixid.favorites.section_orders': 'RECHERCHES COMMANDES',
  'dashboard.pixid.favorites.section_resources': 'RECHERCHES INTÉRIMAIRES',
  'dashboard.pixid.favorites.section_heading_clients':
    'RECHERCHES RUBRIQUES CLIENTS',
  'dashboard.pixid.favorites.section_document_mapping':
    'RECHERCHES MAPPING DES DOCUMENTS',
  'dashboard.pixid.favorites.filters_count': '{{count}} filtre(s)',
  'dashboard.pixid.table.code': 'Code',
  'dashboard.pixid.table.type': 'Type',
  'dashboard.pixid.table.designation': 'Designation',
  'dashboard.pixid.table.label': 'Label',
  'dashboard.pixid.table.platform': 'Platform',
  'dashboard.pixid.no_params':
    'Aucun paramètre de dématérialisation trouvé pour ce client.',
  'dashboard.pixid.no_results':
    'Aucun résultat ne correspond à vos critères de recherche.',
  'dashboard.pixid.filters.title': 'Filtres',
  'dashboard.pixid.filters.reset': 'Réinitialiser les filtres',
  'dashboard.pixid.filters.code': 'Code',
  'dashboard.pixid.filters.designation': 'Désignation',
  'dashboard.pixid.filters.label': 'Label',
  'dashboard.pixid.empty.title': 'Commencez votre recherche',
  'dashboard.pixid.empty.description':
    'Sélectionnez une agence et un client pour afficher les paramètres de dématérialisation.',
  'dashboard.pixid.errors.fetch_platforms':
    'Erreur lors de la récupération des plateformes.',
  'dashboard.pixid.errors.fetch_tenants':
    'Erreur lors de la récupération des tenants.',
  'dashboard.pixid.errors.fetch_agencies':
    'Erreur lors de la récupération des agences.',
  'dashboard.pixid.errors.fetch_clients':
    'Erreur lors de la récupération des clients.',
  'dashboard.pixid.errors.fetch_client_params':
    'Erreur lors de la récupération des paramètres du client.',
  'dashboard.pixid.errors.fetch_parameter_types':
    'Erreur lors de la récupération des types de paramètres.',
  'dashboard.pixid.errors.no_platform':
    'Aucune plateforme disponible. Veuillez contacter un administrateur.',
  'dashboard.pixid.pagination.total': 'paramètres',
  'dashboard.pixid.pagination.per_page': 'paramètres par page',
};

const contractsDashboard = {
  'dashboard.contracts.title': 'Contrats',
  'dashboard.contracts.select_platform': 'Plateforme',
  'dashboard.contracts.select_tenant': 'Sélectionner un Tenant',
  'dashboard.contracts.loading': 'Chargement des contrats',
  'dashboard.contracts.filters.title': 'Filtres',
  'dashboard.contracts.filters.reference': 'Référence',
  'dashboard.contracts.filters.status': 'Statut',
  'dashboard.contracts.filters.agency_code': 'Code Agence',
  'dashboard.contracts.filters.amendment_number': 'N° Avenant',
  'dashboard.contracts.filters.created_at': 'Date de création',
  'dashboard.contracts.filters.updated_at': 'Date de mise à jour',
  'dashboard.contracts.filters.sent_at': "Date d'envoi",
  'dashboard.contracts.filters.apply': 'Appliquer les filtres',
  'dashboard.contracts.filters.reset': 'Réinitialiser',
  'dashboard.contracts.table.id': 'ID',
  'dashboard.contracts.table.reference': 'Référence',
  'dashboard.contracts.table.agency_code': 'Code Agence',
  'dashboard.contracts.table.status': 'Statut',
  'dashboard.contracts.table.amendment_number': 'N° Avenant',
  'dashboard.contracts.table.created_at': 'Date de création',
  'dashboard.contracts.table.updated_at': 'Date de mise à jour',
  'dashboard.contracts.table.sent_to': 'Envoyé à',
  'dashboard.contracts.table.sent_by': 'Envoyé par',
  'dashboard.contracts.table.sent_at': "Date d'envoi",
  'dashboard.contracts.table.errors': 'Erreurs',
  'dashboard.contracts.table.view_errors': 'Voir les erreurs',
  'dashboard.contracts.table.data': 'Données',
  'dashboard.contracts.table.view_data': 'Voir les données',
  'dashboard.contracts.table.order': 'Commande',
  'dashboard.contracts.table.view_order': 'Voir la commande',
  'dashboard.contracts.table.toggle_columns': 'Afficher/Masquer colonnes',
  'dashboard.contracts.table.toggle_all': 'Tout afficher/masquer',
  'dashboard.contracts.table.columns_visible': 'colonnes visibles',
  'dashboard.contracts.table.manage_columns': 'Gérer les colonnes',
  'dashboard.contracts.table.column_management': 'Gestion des colonnes',
  'dashboard.contracts.table.customize_display':
    "Personnalisez l'affichage du tableau",
  'dashboard.contracts.table.hide_all': 'Tout masquer',
  'dashboard.contracts.table.show_all': 'Tout afficher',
  'dashboard.contracts.table.columns_count': 'colonne(s) visible(s)',
  'dashboard.contracts.table.close': 'Fermer',
  'dashboard.contracts.table.filename': 'Nom de fichier',
  'dashboard.contracts.table.platform_contract_id': 'ID contrat VMS',
  // Contract statuses
  'dashboard.contracts.status.pending': 'En attente',
  'dashboard.contracts.status.deposited': 'Déposé',
  'dashboard.contracts.status.inconsistent': 'Incohérent',
  'dashboard.contracts.status.signed': 'Signé',
  'dashboard.contracts.status.stored': 'Stocké',
  'dashboard.contracts.status.archived': 'Archivé',
  'dashboard.contracts.status.canceled': 'Annulé',
  'dashboard.contracts.status.failed': 'Échoué',
  'dashboard.contracts.no_data': 'Aucun contrat trouvé.',
  'dashboard.contracts.empty.title': 'Aucun contrat disponible',
  'dashboard.contracts.empty.description':
    'Sélectionnez un tenant pour afficher les contrats.',
  'dashboard.contracts.errors.fetch_contracts':
    'Erreur lors de la récupération des contrats.',
  'dashboard.contracts.errors.no_tenant': 'Veuillez sélectionner un tenant.',
  'dashboard.contracts.pagination.rows_per_page': 'Lignes par page',
  'dashboard.contracts.pagination.of': 'de',
  'dashboard.contracts.pagination.total': 'contrats',
  'dashboard.contracts.pagination.per_page': 'contrats par page',
  'dashboard.contracts.favorites.title': 'Recherches Favorites',
  'dashboard.contracts.favorites.description':
    'Vous avez {{count}} recherche(s) favorite(s)',
  'dashboard.contracts.favorites.add': 'Ajouter aux favoris',
  'dashboard.contracts.favorites.remove': 'Retirer des favoris',
  'dashboard.contracts.favorites.active_filters': 'Filtres actifs',
  'dashboard.contracts.errors_modal.title': 'Détails des erreurs',
  'dashboard.contracts.errors_modal.contract_number': 'Contrat n\u00b0',
  'dashboard.contracts.errors_modal.last_occurrence': 'Dernière occurrence :',
  'dashboard.contracts.errors_modal.fails_title': 'Erreurs',
  'dashboard.contracts.errors_modal.inconsistencies_title': 'Incohérences',
  'dashboard.contracts.errors_modal.heading': 'Rubrique : ',
  'dashboard.contracts.errors_modal.field': 'Champ',
  'dashboard.contracts.errors_modal.order': 'Commande',
  'dashboard.contracts.errors_modal.contract': 'Contrat',
  'dashboard.contracts.related_order_modal.title': 'Commande associée',
  'dashboard.contracts.related_order_modal.navigate':
    'Ouvrir dans les commandes',
  // Deposit
  'dashboard.contracts.table.actions': 'Actions',
  'dashboard.contracts.table.deposit': 'Redéposer le contrat',
  'dashboard.contracts.deposit.success': 'Contrat redéposé avec succès',
  'dashboard.contracts.deposit.error': 'Erreur lors du redépôt du contrat',
};

const ordersDashboard = {
  'dashboard.orders.title': 'Commandes',
  'dashboard.orders.select_platform': 'Plateforme',
  'dashboard.orders.select_tenant': 'Sélectionner un Tenant',
  'dashboard.orders.loading': 'Chargement des commandes',
  'dashboard.orders.filters.title': 'Filtres',
  'dashboard.orders.filters.reference': 'Numéro de commande',
  'dashboard.orders.filters.agency_code': 'Code Agence',
  'dashboard.orders.filters.created_at': 'Date de création',
  'dashboard.orders.filters.updated_at': 'Date de mise à jour',
  'dashboard.orders.filters.reset': 'Réinitialiser les filtres',
  'dashboard.orders.table.id': 'ID',
  'dashboard.orders.table.agency_code': 'Code Agence',
  'dashboard.orders.table.siret': 'SIRET',
  'dashboard.orders.table.reference': 'Numéro de commande',
  'dashboard.orders.table.platform': 'Plateforme',
  'dashboard.orders.table.tenant': 'Tenant',
  'dashboard.orders.table.created_at': 'Date de création',
  'dashboard.orders.table.updated_at': 'Date de mise à jour',
  'dashboard.orders.table.data': 'Données',
  'dashboard.orders.table.view_data': 'Voir les données',
  'dashboard.orders.table.contract': 'Contrat',
  'dashboard.orders.table.view_contract': 'Voir le contrat',
  'dashboard.orders.related_contract_modal.title': 'Contrat associé',
  'dashboard.orders.related_contract_modal.navigate':
    'Ouvrir dans les contrats',
  'dashboard.orders.table.columns_visible': 'colonnes visibles',
  'dashboard.orders.table.toggle_columns': 'Gérer les colonnes',
  'dashboard.orders.table.manage_columns': 'Gérer les colonnes',
  'dashboard.orders.table.platform_order_id': 'ID commande VMS',
  'dashboard.orders.no_data': 'Aucune commande trouvée.',
  'dashboard.orders.empty.title': 'Aucune commande trouvée',
  'dashboard.orders.empty.description':
    'Sélectionnez un tenant pour afficher les commandes.',
  'dashboard.orders.empty.no_matching_filters':
    'Aucune commande ne correspond aux filtres appliqués',
  'dashboard.orders.empty.not_available': 'Aucune commande disponible',
  'dashboard.orders.errors.fetch_orders':
    'Erreur lors de la récupération des commandes.',
  'dashboard.orders.pagination.total': 'commandes',
  'dashboard.orders.pagination.per_page': 'commandes par page',
  'dashboard.orders.favorites.add': 'Ajouter aux favoris',
  'dashboard.orders.favorites.remove': 'Retirer des favoris',
  'dashboard.orders.favorites.active_filters': 'Filtres actifs',
};

const resourcesDashboard = {
  'dashboard.resources.title': 'Intérimaires',
  'dashboard.resources.select_platform': 'Plateforme',
  'dashboard.resources.select_tenant': 'Sélectionner un Tenant',
  'dashboard.resources.loading': 'Chargement des intérimaires',
  'dashboard.resources.filters.title': 'Filtres',
  'dashboard.resources.filters.firstname': 'Prénom',
  'dashboard.resources.filters.lastname': 'Nom',
  'dashboard.resources.filters.email': 'Email',
  'dashboard.resources.filters.phone': 'Téléphone',
  'dashboard.resources.filters.created_at': 'Date de création',
  'dashboard.resources.filters.updated_at': 'Date de mise à jour',
  'dashboard.resources.filters.sent_at': "Date d'envoi",
  'dashboard.resources.filters.reset': 'Réinitialiser les filtres',
  'dashboard.resources.table.id': 'ID',
  'dashboard.resources.table.firstname': 'Prénom',
  'dashboard.resources.table.lastname': 'Nom',
  'dashboard.resources.table.email': 'Email',
  'dashboard.resources.table.phone': 'Téléphone',
  'dashboard.resources.table.platform_resource_id': 'ID Ressource',
  'dashboard.resources.table.sent_to': 'Envoyé à',
  'dashboard.resources.table.sent_by': 'Envoyé par',
  'dashboard.resources.table.sent_at': "Date d'envoi",
  'dashboard.resources.table.created_at': 'Date de création',
  'dashboard.resources.table.updated_at': 'Date de mise à jour',
  'dashboard.resources.table.contracts': 'Contrats',
  'dashboard.resources.table.view_contracts': 'Voir les contrats',
  'dashboard.resources.table.view_contract_details':
    'Voir les détails du contrat',
  'dashboard.resources.table.data': 'Données',
  'dashboard.resources.table.view_data': 'Voir les données',
  'dashboard.resources.table.toggle_columns': 'Afficher/Masquer colonnes',
  'dashboard.resources.table.columns_visible': 'colonnes visibles',
  'dashboard.resources.no_data': 'Aucun intérimaire trouvé.',
  'dashboard.resources.errors.fetch_resources':
    'Erreur lors de la récupération des intérimaires.',
  'dashboard.resources.pagination.total': 'intérimaires',
  'dashboard.resources.pagination.per_page': 'intérimaires par page',
  'dashboard.resources.favorites.add': 'Ajouter aux favoris',
  'dashboard.resources.favorites.remove': 'Retirer des favoris',
  'dashboard.resources.favorites.active_filters': 'Filtres actifs',
};

const headingClientsDashboard = {
  'dashboard.heading_clients.title': 'Rubriques Clients',
  'dashboard.heading_clients.no_data': 'Aucune rubrique client trouvée',
  'dashboard.heading_clients.no_matching_filters':
    'Aucune rubrique client ne correspond aux filtres appliqués',
  'dashboard.heading_clients.not_available':
    'Aucune rubrique client disponible',
  'dashboard.heading_clients.filters.code': 'Code',
  'dashboard.heading_clients.filters.agency_code': 'Code agence',
  'dashboard.heading_clients.filters.client_code': 'Code client',
  'dashboard.heading_clients.filters.anael_value': 'Valeur Anael',
  'dashboard.heading_clients.filters.platform_value': 'Valeur plateforme',
  'dashboard.heading_clients.errors.fetch_heading_clients':
    'Erreur lors de la récupération des rubriques clients.',
  'dashboard.heading_clients.errors.import':
    "Échec de l'import du fichier. Veuillez réessayer.",
  'dashboard.heading_clients.import.success':
    'Import des rubriques clients effectué avec succès',
  'dashboard.heading_clients.pagination.total': 'rubriques',
  'dashboard.heading_clients.pagination.per_page': 'rubriques par page',
  'dashboard.heading_clients.table.import': 'Importer',
  'dashboard.heading_clients.table.import_tooltip':
    "Importer les rubriques à partir d'un fichier",
  'dashboard.heading_clients.table.import_anael': 'Importer depuis Anael',
  'dashboard.heading_clients.table.import_anael_tooltip':
    'Importer les rubriques depuis Anael',
  'dashboard.heading_clients.table.id': 'ID',
  'dashboard.heading_clients.table.platform': 'Plateforme',
  'dashboard.heading_clients.table.agency_code': 'Code agence',
  'dashboard.heading_clients.table.client_code': 'Code client',
  'dashboard.heading_clients.table.code': 'Code',
  'dashboard.heading_clients.table.anael_value': 'Valeur Anael',
  'dashboard.heading_clients.table.platform_value': 'Valeur platforme',
  'dashboard.heading_clients.table.created_at': 'Date de création',
  'dashboard.heading_clients.table.updated_at': 'Date de mise à jour',
  'dashboard.heading_clients.select_platform': 'Plateforme',
  'dashboard.heading_clients.favorites.add':
    'Ajouter cette recherche aux favoris',
  'dashboard.heading_clients.favorites.remove':
    'Retirer cette recherche des favoris',
  'dashboard.heading_clients.favorites.active_filters': 'Filtres actifs',
  'dashboard.heading_clients.table.actions': 'Actions',
  'dashboard.heading_clients.table.edit': 'Modifier',
  'dashboard.heading_clients.table.delete': 'Supprimer',
  'dashboard.heading_clients.table.download_rubrics':
    'Télécharger le fichier de rubriques',
  'dashboard.heading_clients.download.error':
    'Erreur lors du téléchargement du fichier de rubriques',
  'dashboard.heading_clients.create.button': 'Créer une rubrique client',
  'dashboard.heading_clients.create.title': 'Créer une Rubrique Client',
  'dashboard.heading_clients.create.success':
    'Rubrique client créée avec succès',
  'dashboard.heading_clients.create.error':
    'Erreur lors de la création de la rubrique client',
  'dashboard.heading_clients.create.submit': 'Créer',
  'dashboard.heading_clients.create.cancel': 'Annuler',
  'dashboard.heading_clients.create.field.agency_code': 'Code agence',
  'dashboard.heading_clients.create.field.client_code': 'Code client',
  'dashboard.heading_clients.create.field.code': 'Code',
  'dashboard.heading_clients.create.field.anael_value': 'Valeur Anael',
  'dashboard.heading_clients.create.field.platform_value': 'Valeur plateforme',
  'dashboard.heading_clients.create.field.platform': 'Plateforme',
  'dashboard.heading_clients.edit.title': 'Modifier la Rubrique Client',
  'dashboard.heading_clients.edit.success':
    'Rubrique client modifiée avec succès',
  'dashboard.heading_clients.edit.error':
    'Erreur lors de la modification de la rubrique client',
  'dashboard.heading_clients.edit.submit': 'Enregistrer',
  'dashboard.heading_clients.edit.cancel': 'Annuler',
  'dashboard.heading_clients.delete.success':
    'Rubrique client supprimée avec succès',
  'dashboard.heading_clients.delete.error':
    'Erreur lors de la suppression de la rubrique client',
  'dashboard.heading_clients.delete.confirm.title': 'Confirmer la suppression',
  'dashboard.heading_clients.delete.confirm.message':
    'Êtes-vous sûr de vouloir supprimer cette rubrique client ? Cette action est irréversible.',
  'dashboard.heading_clients.delete.confirm.yes': 'Supprimer',
  'dashboard.heading_clients.delete.confirm.no': 'Annuler',
};

const documentMappingDashboard = {
  'dashboard.document_mapping.title': 'Mapping des documents',
  'dashboard.document_mapping.no_data': 'Aucun document trouvé',
  'dashboard.document_mapping.no_matching_filters':
    'Aucun document ne correspond aux filtres appliqués',
  'dashboard.document_mapping.not_available': 'Aucun document disponible',
  'dashboard.document_mapping.filters.code': 'Code',
  'dashboard.document_mapping.filters.category': 'Catégorie',
  'dashboard.document_mapping.filters.code_vms': 'Code VMS',
  'dashboard.document_mapping.filters.category_vms': 'Catégorie VMS',
  'dashboard.document_mapping.filters.label': 'Libellé',
  'dashboard.document_mapping.filters.platform': 'Plateforme',
  'dashboard.document_mapping.filters.is_gdpr': 'RGPD',
  'dashboard.document_mapping.errors.fetch_document_mapping':
    'Erreur lors de la récupération des documents.',
  'dashboard.document_mapping.pagination.total': 'documents',
  'dashboard.document_mapping.pagination.per_page': 'documents par page',
  'dashboard.document_mapping.table.id': 'ID',
  'dashboard.document_mapping.table.code': 'Code',
  'dashboard.document_mapping.table.category': 'Catégorie',
  'dashboard.document_mapping.table.code_vms': 'Code VMS',
  'dashboard.document_mapping.table.category_vms': 'Catégorie VMS',
  'dashboard.document_mapping.table.label': 'Libellé',
  'dashboard.document_mapping.table.platform': 'Plateforme',
  'dashboard.document_mapping.table.is_gdpr': 'RGPD',
  'dashboard.document_mapping.table.created_at': 'Date de création',
  'dashboard.document_mapping.table.updated_at': 'Date de mise à jour',
  'dashboard.document_mapping.select_platform': 'Plateforme',
  'dashboard.document_mapping.favorites.add':
    'Ajouter cette recherche aux favoris',
  'dashboard.document_mapping.favorites.remove':
    'Retirer cette recherche des favoris',
  'dashboard.document_mapping.favorites.active_filters': 'Filtres actifs',
  'dashboard.document_mapping.create.button': 'Créer un mapping',
  'dashboard.document_mapping.create.title': 'Créer un Mapping de Document',
  'dashboard.document_mapping.create.success':
    'Mapping de document créé avec succès',
  'dashboard.document_mapping.create.error':
    'Erreur lors de la création du mapping de document',
  'dashboard.document_mapping.create.submit': 'Créer',
  'dashboard.document_mapping.create.cancel': 'Annuler',
  'dashboard.document_mapping.create.field.code': 'Code',
  'dashboard.document_mapping.create.field.category': 'Catégorie',
  'dashboard.document_mapping.create.field.code_vms': 'Code VMS',
  'dashboard.document_mapping.create.field.category_vms': 'Catégorie VMS',
  'dashboard.document_mapping.create.field.label': 'Libellé',
  'dashboard.document_mapping.create.field.platform': 'Plateforme',
  'dashboard.document_mapping.create.field.is_gdpr': 'Protégé par le RGPD',
  'dashboard.document_mapping.edit.title': 'Modifier le Mapping de Document',
  'dashboard.document_mapping.edit.success':
    'Mapping de document modifié avec succès',
  'dashboard.document_mapping.edit.error':
    'Erreur lors de la modification du mapping de document',
  'dashboard.document_mapping.edit.submit': 'Enregistrer',
  'dashboard.document_mapping.edit.cancel': 'Annuler',
  'dashboard.document_mapping.table.actions': 'Actions',
  'dashboard.document_mapping.table.edit': 'Modifier',
  'dashboard.document_mapping.table.delete': 'Supprimer',
  'dashboard.document_mapping.delete.success':
    'Mapping de document supprimé avec succès',
  'dashboard.document_mapping.delete.error':
    'Erreur lors de la suppression du mapping de document',
  'dashboard.document_mapping.delete.confirm.title': 'Confirmer la suppression',
  'dashboard.document_mapping.delete.confirm.message':
    'Êtes-vous sûr de vouloir supprimer ce mapping de document ? Cette action est irréversible.',
  'dashboard.document_mapping.delete.confirm.yes': 'Supprimer',
  'dashboard.document_mapping.delete.confirm.no': 'Annuler',
};

const clientVmsConfigDashboard = {
  'dashboard.client_vms_config.title': 'Configuration Client VMS',
  'dashboard.client_vms_config.no_data':
    'Aucune configuration client VMS trouvée',
  'dashboard.client_vms_config.no_matching_filters':
    'Aucune configuration ne correspond aux filtres appliqués',
  'dashboard.client_vms_config.not_available':
    'Aucune configuration client VMS disponible',
  'dashboard.client_vms_config.filters.agency_code': 'Code agence',
  'dashboard.client_vms_config.filters.client_code': 'Code client',
  'dashboard.client_vms_config.filters.siret': 'SIRET',
  'dashboard.client_vms_config.filters.platform': 'Plateforme',
  'dashboard.client_vms_config.filters.tenant': 'Tenant',
  'dashboard.client_vms_config.errors.fetch':
    'Erreur lors de la récupération des configurations client VMS.',
  'dashboard.client_vms_config.pagination.total': 'configurations',
  'dashboard.client_vms_config.pagination.per_page': 'configurations par page',
  'dashboard.client_vms_config.table.id': 'ID',
  'dashboard.client_vms_config.table.agency_code': 'Code agence',
  'dashboard.client_vms_config.table.client_code': 'Code client',
  'dashboard.client_vms_config.table.siret': 'SIRET',
  'dashboard.client_vms_config.table.platform': 'Plateforme',
  'dashboard.client_vms_config.table.tenant': 'Tenant',
  'dashboard.client_vms_config.table.created_at': 'Date de création',
  'dashboard.client_vms_config.table.updated_at': 'Date de mise à jour',
  'dashboard.client_vms_config.table.actions': 'Actions',
  'dashboard.client_vms_config.table.edit': 'Modifier',
  'dashboard.client_vms_config.table.delete': 'Supprimer',
  'dashboard.client_vms_config.create.button': 'Créer une configuration',
  'dashboard.client_vms_config.create.title':
    'Créer une Configuration Client VMS',
  'dashboard.client_vms_config.create.success':
    'Configuration client VMS créée avec succès',
  'dashboard.client_vms_config.create.error':
    'Erreur lors de la création de la configuration client VMS',
  'dashboard.client_vms_config.create.submit': 'Créer',
  'dashboard.client_vms_config.create.cancel': 'Annuler',
  'dashboard.client_vms_config.create.field.agency_code': 'Code agence',
  'dashboard.client_vms_config.create.field.client_code': 'Code client',
  'dashboard.client_vms_config.create.field.siret': 'SIRET',
  'dashboard.client_vms_config.create.field.platform': 'Plateforme',
  'dashboard.client_vms_config.create.field.tenant': 'Tenant',
  'dashboard.client_vms_config.edit.title':
    'Modifier la Configuration Client VMS',
  'dashboard.client_vms_config.edit.success':
    'Configuration client VMS modifiée avec succès',
  'dashboard.client_vms_config.edit.error':
    'Erreur lors de la modification de la configuration client VMS',
  'dashboard.client_vms_config.edit.submit': 'Enregistrer',
  'dashboard.client_vms_config.edit.cancel': 'Annuler',
  'dashboard.client_vms_config.delete.success':
    'Configuration client VMS supprimée avec succès',
  'dashboard.client_vms_config.delete.error':
    'Erreur lors de la suppression de la configuration client VMS',
  'dashboard.client_vms_config.delete.confirm.title':
    'Confirmer la suppression',
  'dashboard.client_vms_config.delete.confirm.message':
    'Êtes-vous sûr de vouloir supprimer cette configuration client VMS ? Cette action est irréversible.',
  'dashboard.client_vms_config.delete.confirm.yes': 'Supprimer',
  'dashboard.client_vms_config.delete.confirm.no': 'Annuler',
};

const error = {
  'error.404.title': 'Page Introuvable',
  'error.404.description': "La page que vous recherchez n'existe pas.",
  'error.404.action.home': "Retour à l'Accueil",
  'error.boundary.title': 'Une erreur est survenue',
  'error.boundary.description':
    "Une erreur inattendue s'est produite. Rechargez la page pour continuer.",
  'error.boundary.reload': 'Recharger la page',
};

const pageTitle = {
  'page.title.home': 'Accueil',
  'page.title.dashboard': 'Tableau de bord',
  'page.title.testcafe_builder': 'TestCafe Builder',
  'page.title.not_found': 'Page non trouvée',
  'page.title.app_name': 'Vera',
};

const platform = {
  'platform.access_denied.title': 'Accès Refusé',
  'platform.access_denied.message':
    "Vous n'avez pas accès à la plateforme {{platform}}.",
  'platform.access_denied.contact':
    'Veuillez contacter votre administrateur pour obtenir les permissions nécessaires.',
};

const table = {
  'table.empty': 'Aucun résultat',
  'table.columns.count': '{{visible}} / {{total}} colonnes',
  'table.columns.manage': 'Gérer les colonnes',
  'table.columns.toggle_all': 'Tout afficher',
  'table.row_actions': 'Actions',
};

const pagination = {
  'pagination.page_size': 'Résultats par page',
  'pagination.per_page': 'par page',
  'pagination.of': 'sur',
  'pagination.previous': 'Page précédente',
  'pagination.next': 'Page suivante',
};

const combobox = {
  'combobox.search': 'Rechercher…',
  'combobox.empty': 'Aucun résultat',
  'combobox.loading': 'Chargement…',
  'combobox.placeholder': 'Sélectionner',
  'combobox.clear': 'Effacer',
};

const select = {
  'select.all': 'Tous',
};

const defaultExport = {
  ...common,
  ...action,
  ...combobox,
  ...select,
  ...api,
  ...homepage,
  ...headerMenu,
  ...footer,
  ...footerMenu,
  ...notifications,
  ...userMenu,
  ...layout,
  ...authError,
  ...dashboard,
  ...pixidDashboard,
  ...contractsDashboard,
  ...ordersDashboard,
  ...resourcesDashboard,
  ...headingClientsDashboard,
  ...documentMappingDashboard,
  ...clientVmsConfigDashboard,
  ...error,
  ...pageTitle,
  ...platform,
  ...table,
  ...pagination,
};

export default defaultExport;
